var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"ico_more",on:{"click":function($event){$event.stopPropagation();return _vm.onLinkClick($event)}}},[_vm._v("보러가기")])}
var staticRenderFns = []

export { render, staticRenderFns }